import { useContext, useMemo } from "react";

import BryntumContext from "@/react/context/bryntumContext.jsx";
import useViews from "@/react/hooks/useViews";
import { VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";

export interface NotificationScope {
  isAccountView: boolean;
  boardId: number | null;
}

export function useNotificationScope(): NotificationScope {
  const viewManagerState = useViews();
  const { selectedBoard } = useContext(BryntumContext);

  const viewType = viewManagerState?.selectedView?.viewType;
  const isAccountView = viewType === VIEW_TYPES.mySwivu;

  return useMemo(
    () => ({
      isAccountView,
      boardId:
        selectedBoard?.id != null ? Number(selectedBoard.id) : null,
    }),
    [isAccountView, selectedBoard?.id],
  );
}
